import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "kn-truncated" }
const _hoisted_2 = { class: "table-header p-d-flex p-ai-center" }
const _hoisted_3 = {
  id: "search-container",
  class: "p-input-icon-left p-mr-3"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_5 = { class: "kn-truncated" }
const _hoisted_6 = { class: "p-d-flex p-flex-row p-jc-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Dialog = _resolveComponent("Dialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Card, { class: "p-mb-3" }, {
      header: _withCtx(() => [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-p-0 p-m-0 p-col-12" }, {
          start: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.dataset')), 1)
          ]),
          end: _withCtx(() => [
            (_ctx.documentData.selectedDataset.length === 0)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "p-button-link",
                  label: _ctx.$t('workspace.gis.dnl.addDataset'),
                  onClick: _ctx.showDatasetDialog
                }, null, 8, ["label", "onClick"]))
              : (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  class: "p-button-link",
                  label: _ctx.$t('workspace.gis.dnl.changeDataset'),
                  onClick: _ctx.showDatasetDialog
                }, null, 8, ["label", "onClick"]))
          ]),
          _: 1
        })
      ]),
      content: _withCtx(() => [
        _createVNode(_component_DataTable, {
          class: "p-datatable-sm kn-table georef-step1-table",
          value: _ctx.documentData.selectedDataset,
          dataKey: "id",
          responsiveLayout: "scroll",
          breakpoint: "600px"
        }, {
          empty: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('workspace.gis.dnl.emptyInfo')), 1)
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
              return (_openBlock(), _createBlock(_component_Column, {
                field: col.field,
                header: _ctx.$t(col.header),
                key: col.field
              }, {
                body: _withCtx(({data}) => [
                  _withDirectives(_createVNode("span", _hoisted_1, [
                    _createTextVNode(_toDisplayString(data[col.field]), 1)
                  ], 512), [
                    [
                      _directive_tooltip,
                      data[col.field],
                      void 0,
                      { top: true }
                    ]
                  ])
                ]),
                _: 2
              }, 1032, ["field", "header"]))
            }), 128)),
            _createVNode(_component_Column, {
              style: _ctx.styleDescriptor.style.trashColumn,
              onRowClick: false
            }, {
              body: _withCtx(() => [
                _createVNode(_component_Button, {
                  icon: "pi pi-trash",
                  class: "p-button-link",
                  onClick: _ctx.deleteSelectedDataset
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _: 1
    }),
    (_ctx.datasetDialogVisible)
      ? (_openBlock(), _createBlock(_component_Dialog, {
          key: 0,
          class: "p-fluid kn-dialog--toolbar--primary",
          style: _ctx.styleDescriptor.style.dialogSize,
          visible: _ctx.datasetDialogVisible,
          modal: true,
          closable: false
        }, {
          header: _withCtx(() => [
            _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
              start: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('workspace.gis.dnl.datasetList')), 1)
              ]),
              _: 1
            })
          ]),
          footer: _withCtx(() => [
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_Button, {
                class: "kn-button kn-button--secondary",
                onClick: _ctx.closeDialog
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_Button, {
                class: "kn-button kn-button--primary",
                onClick: _ctx.saveDatasetSelection
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_DataTable, {
              class: "p-datatable-sm kn-table kn-width-full",
              value: _ctx.availableDatasets,
              dataKey: "id",
              selection: _ctx.selectedDataset,
              "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedDataset = $event)),
              selectionMode: "single",
              scrollable: true,
              scrollHeight: "40vh",
              filters: _ctx.filters,
              "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters = $event)),
              globalFilterFields: _ctx.globalFilterFields,
              loading: _ctx.loading,
              responsiveLayout: "scroll"
            }, {
              header: _withCtx(() => [
                _createVNode("div", _hoisted_2, [
                  _createVNode("span", _hoisted_3, [
                    _hoisted_4,
                    _createVNode(_component_InputText, {
                      class: "kn-material-input",
                      modelValue: _ctx.filters['global'].value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
                      placeholder: _ctx.$t('common.search')
                    }, null, 8, ["modelValue", "placeholder"])
                  ])
                ])
              ]),
              empty: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('workspace.gis.dnl.dialogEmptyInfo')), 1)
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
                  return (_openBlock(), _createBlock(_component_Column, {
                    field: col.field,
                    header: _ctx.$t(col.header),
                    key: col.field
                  }, {
                    body: _withCtx(({data}) => [
                      _withDirectives(_createVNode("span", _hoisted_5, [
                        _createTextVNode(_toDisplayString(data[col.field]), 1)
                      ], 512), [
                        [
                          _directive_tooltip,
                          data[col.field],
                          void 0,
                          { top: true }
                        ]
                      ])
                    ]),
                    _: 2
                  }, 1032, ["field", "header"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value", "selection", "filters", "globalFilterFields", "loading"])
          ]),
          _: 1
        }, 8, ["style", "visible"]))
      : _createCommentVNode("", true)
  ], 64))
}